export default __webpack_public_path__ + "assets/albania-flag.png";